<template>
   <section class="text-align: left;">
     <!-- XOL-526 (UX §2.1): title-only banner for a backhaul provider on a
          closed/rejected RTB. Placed first, ahead of the status header. -->
     <el-row v-if="isProviderOnlyViewer()">
       <el-col :span="24">
         <el-alert
           type="info"
           :title="'You are viewing this ' + actionData.actionType + ' as its backhaul provider.'"
           show-icon
           :closable="false" />
       </el-col>
     </el-row>

     <el-row>
       <el-col :span="24" align="center">

         <h3>
           <small> <span :class="statusClass()">{{actionData.status}}: </span><i :class="actionData.workflow.icon"></i> {{actionData.workflow.name}}:</small>
           <b>{{actionData.site.siteName}}</b> | <i :class="'fa fa-' + statusIcon() + ' ' + statusClass()"></i>
         </h3>

         <br />

         <h4>
           <small>by:</small> <b :class="statusClass()">{{actionData.organisation.name}}</b>
         </h4>

         <br />

         <small v-if="actionData.completed_at || actionData.completed_by" class="text-muted">
           {{actionData.actionType}} completed&nbsp;
           <span v-if="actionData.completed_at">on <b>{{formatDate(actionData.completed_at)}}</b></span>
           <span v-if="actionData.completed_by"> by <b>{{actionData.completed_by}}</b></span>
         </small>
       </el-col>
     </el-row>

     <el-row>

       <div v-if="actionData.parties > 1">

         <el-col :span="23">
          <el-tabs v-model="selectedTab" type="border-card">
            <!-- XOL-393: panes carry an explicit :name. Without one Element UI names
                 them positionally ("0","1") while every other party reference here is
                 a partyNo (1,2), so v-model could never match a pane and the first one
                 (party 1) always won — a telco opening a completed request landed on
                 the Tower Co's files rather than its own. -->
            <el-tab-pane v-for="partyNo in actionData.parties" :key="partyNo" :name="String(partyNo)" :label="partyTabLabel(partyNo)">

             <files-table
             :title="partyName(partyNo)"
             :id="getFileTableRef(partyNo)"
             :name="getFileTableRef(partyNo)"
             :table-ref="'filestable' + partyNo"
             :site-id="actionData.site_id"
             :type="actionData.actionType.toLowerCase()"
             :type-id="actionData.id"
             :partyNo="partyNo"
             :disable-form="true"
             size="text"
             :show-file-name="false"
             :show-refresh="false"
             :show-search="false"
             />

             <!-- XOL-526 (UX §1.7(b)) -->
             <p v-if="Number(partyNo) === 2 && hasDistinctProvider()" class="text-muted">
               <small><i class="fa fa-users" aria-hidden="true"></i> {{sharedFilesCue()}}</small>
             </p>

        </el-tab-pane>

      </el-tabs>
       </el-col>

     </div>
   </el-row>

    <el-collapse v-model="accordion" v-if="steps && steps[0].comp" accordion>

      <el-collapse-item v-for="(s, index) in steps"
        :key="s.title"
        :name="'' + index">
         <template #title>
           <b class="text-primary"><i :class="s.icon">&nbsp;</i>{{s.title}}</b>
         </template>

         <el-form>
           <component v-if="actionData && s.comp && s.data" v-bind="s.data" :is="s.comp" />
         </el-form>

      </el-collapse-item>

    </el-collapse>

   <small class="text-muted">{{actionData.actionType}} completed on <b>{{formatDate(actionData.completed_at)}}</b> by <b>{{actionData.completed_by}}</b></small>

 </section>
</template>

<script>

import RequestMixins from '@/mixins/RequestMixins'

import FilesTable from '@/components/tables/FilesTable'

import step1 from '@/components/requests/workflow/step1'
import step2 from '@/components/requests/workflow/step2'
import step3 from '@/components/requests/workflow/step3'
import step4 from '@/components/requests/workflow/step4'
import step5 from '@/components/requests/workflow/step5'
import SiteMap from '@/components/requests/SiteMap'

export default {
  mixins: [RequestMixins],

  components: {
    FilesTable,
    step1,
    step2,
    step3,
    step4,
    step5,
    SiteMap
  },

  props: {
    rowData: {
      type: Object,
      default: null
    },

    rowIndex: {
      type: Number,
      default: null
    }

  },

  methods: {


    statusClass () {
      return this.actionData.status === 'Closed' ? 'text-success' : 'text-warning'
    },

    statusIcon () {
      return this.actionData.status === 'Closed' ? 'flag' : 'exclamation-triangle'
    },

    partyName (partyNo) {

      if (!partyNo && !this.actionData.steps) {
        return 'Not Found'
      } else {

        for (let i = 0; i < this.actionData.steps.length; i++) {
          let wf = this.actionData.steps[i]

          wf.stepNo = Number(wf.stepNo)
          wf.partyNo = Number(wf.partyNo)

          if (wf.stepNo === 1 && wf.partyNo === partyNo) {
            return (this.isDesktop ? wf.org.name : wf.org.shortName)
          }

        } // for

        return 'Not Found'
      }
    },

    getFileTableRef (pNo) {
      // XOL-393: this component has no activeStep (these are the whole-request
      // summary tables, not per-step ones) — it was emitting DOM ids/names of
      // literally "filestableundefined-1" / "-2".
      return 'filestable-summary-' + pNo
    },

    getStep (stepNo) {

      switch (stepNo) {
        case 1:
          this.comp = step1
          break
        case 2:
          this.comp = step2
          break
        case 3:
          this.comp = step3
          break
        case 4:
          this.comp = step4
          break
        case 5:
          this.comp = step5
          break
        default:
          this.comp = step1
      }

      return this.comp
    },

    stepData (current = 1, partyNo = 1) {
      if (this.rowData.steps && this.rowData.steps.length > 0) {

        for (var i = 0; i < this.rowData.steps.length; i++) {
          var s = this.rowData.steps[i]

          if (Number(s.stepNo) === current && Number(s.partyNo) === partyNo) {
            return s
          }

        }
      }

      return null
    }

  },

  data () {
    return {
      orgId: this.isTelco() ? this.org().id : this.xolasClient().id,
      actionData: this.rowData,
      selectedTab: null,
      accordion: '0',
      steps: null
    }
  },

  created () {

    // XOL-526: was `this.rowData.organisation_id === this.org().id ? 2 : 1` —
    // that only recognised the telco owner. viewerPartyNo() also puts a
    // backhaul provider on party 2 (and stays 1 for a single-party workflow).
    let partyNo = this.viewerPartyNo()

    // XOL-393: open on the viewer's OWN party tab. selectedTab was left null, so
    // el-tabs fell back to the first pane and a telco always landed on the Tower Co's
    // files — reported as "telco tab files do not render".
    this.selectedTab = String(partyNo)

    this.steps = this.workflow(partyNo, this.actionData.steps)

    for (var i = 0; i < this.steps.length; i++) {
      this.steps[i].comp = this.getStep(i + 1)
      this.steps[i].data = {
        rowData: this.rowData,
        rowIndex: this.rowIndex,
        stepData: this.stepData(i + 1)
      }
    }  // for

    this.steps.push({title: 'Location Map', icon: 'fa fa-map-marked-alt', comp: SiteMap, data: {rowData: this.rowData}})
  }
}

</script>
